import { z } from 'zod';
import { lenderDeskingDataShema } from '../model';

export enum LenderDeskingSections {
  STRUCTURE = 'structure',
  EQUIPMENT = 'equipment',
  SEND = 'send',
}

export type LenderDeskingPanelFormValues = z.infer<typeof lenderDeskingDataShema>;
